import { QuizQuestionTypeProps } from '../types';
import { ShortAnswerQuestion } from '../ShortAnswerQuestion';

export function NumericalQuestion(props: QuizQuestionTypeProps) {
  return <ShortAnswerQuestion type={'number'} {...props} />;
}
